module.exports = __webpack_public_path__ + "static/juan-zarate.fdf8b7d3.webp";